import { Link, Switch, useTheme } from '@mui/material';
import React from 'react'
import linkedAccountsSectionStyles from '../Accounts/LinkedAccountsSection.styles';
import { useTranslation } from '../../hooks/useTranslation';

function SelectAll(props) {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
      <Link
        display={props.consentsNum>1?"block":"none"}
        color={theme.palette.primary.main}
        onClick={() => {
          props.toggleSelectAll();
        }}
        sx={linkedAccountsSectionStyles.changeNumberLink}
      >
        {t('common.buttons.selectAll')}
        <Switch
          checked={props.selectAll}
          onChange={props.toggleSelectAll}
          inputProps={{ 'aria-label': 'controlled' }}
        />
      </Link>  )
}

export default SelectAll